var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGbFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "GB"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Mask",
    y: 0.928467,
    width: 24,
    height: 17.1429,
    rx: 1.71429,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2825_8083",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 19
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Mask_2",
    y: 0.928467,
    width: 24,
    height: 17.1429,
    rx: 1.71429,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2825_8083)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Mask Copy",
    y: 0.928467,
    width: 24,
    height: 17.1429,
    fill: "#0A17A7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.72073 12.3572L-2.37695 17.8192L-1.0988 19.7141L9.14315 12.8058V19.2144H14.8574V12.8056L25.0998 19.7142L26.3779 17.8192L18.2802 12.3572H24.0003V6.64291H18.28L26.3779 1.18083L25.0998 -0.714111L14.8574 6.19442V-0.214238H9.14315V6.1942L-1.09877 -0.714064L-2.37693 1.18088L5.72087 6.64291H0.000282288V12.3572H5.72073Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line",
    d: "M16.002 6.35625L26.858 -0.785645",
    stroke: "#DB1F35",
    strokeWidth: 0.571429,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line Copy 2",
    d: "M17.1543 12.6694L26.8862 19.229",
    stroke: "#DB1F35",
    strokeWidth: 0.571429,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line Copy",
    d: "M6.86211 6.33759L-3.28906 -0.503662",
    stroke: "#DB1F35",
    strokeWidth: 0.571429,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line Copy 3",
    d: "M7.96311 12.5898L-3.28906 20.0518",
    stroke: "#DB1F35",
    strokeWidth: 0.571429,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2 Copy 3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 11.2142H10.2857V18.0713H13.7143V11.2142H24V7.78562H13.7143V0.928467H10.2857V7.78562H0V11.2142Z",
    fill: "#E6273E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGbFlag);
export default __webpack_public_path__ + "static/media/gb-flag.114c96447ac942e4bfe18eabcd7070d8.svg";
export { ForwardRef as ReactComponent };